import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { replaceItemsByParams } from '@nike/ux-tread-cart';
import { SERVICE_UPDATE_ITEM } from '@nike/cart-constants';
import { DOTCOM_UX_ID, NIKECOM_CHANNEL, NIKE_BRAND } from '@nike/ux-tread-dotcom-constants';
import { onFetchStart, onFetchSuccess } from './action-creators';
import handleCartErrors from './handle-cart-errors';
import { createItemData } from '../utils';

/**
 * updateCartItem is a thunk that updates a single cart line item
 *
 * @param {object} params - named parameters
 * @param {object} params.giftCard - giftCard object with amount:price
 * @param {object} params.shippingAddress - shipping address object
 * @param {string} params.shippingMethod - shipping method
 * @param {string} params.id - line item id - if preexisting update item else create line item
 * @param {string} [params.appId=DOTCOM_UX_ID] - app id for headers to identify client in logs
 * @param {string} params.token - consumer jwt, user token
 * @param {string} params.visitId - unite visit id
 * @param {string} params.visitorId - unite visitor id
 * @param {string} [params.brand=NIKE_BRAND] - brand is a differentiation for carts, by default it's set to NIKE
 * @param {string} [params.channel=NIKECOM_CHANNEL] - channel is a differentiation for carts, by default it's set to NIKECOM
 * @param {string} params.country - 2 letter ISO country code
 * @param {string} params.cloudStack - aws stack name to include in headers, by default undefined which points to production
 * @param {string} params.host - host name to use when calling cart service
 * @param {string} params.offer - offer to patch to cart item
 * @param {string} params.offers - offers to patch to cart item
 * @param {Array} params.items - array of items to be patched in the cart
 * @param {Array} params.valueAddedServices - array of valueAddedServices to be patched in the item in cart
 * @param {number} params.quantity - item quantity to replace
 * @param {string} params.skuId - item skuId to replace
 * @param {object} params.recipient - gift card recipient
 * @returns {Promise} fetch promise
 */
export default function updateCartItem(_ref) {
  var _ref$appId = _ref.appId,
    appId = _ref$appId === void 0 ? DOTCOM_UX_ID : _ref$appId,
    _ref$brand = _ref.brand,
    brand = _ref$brand === void 0 ? NIKE_BRAND : _ref$brand,
    _ref$channel = _ref.channel,
    channel = _ref$channel === void 0 ? NIKECOM_CHANNEL : _ref$channel,
    cloudStack = _ref.cloudStack,
    country = _ref.country,
    giftCard = _ref.giftCard,
    host = _ref.host,
    id = _ref.id,
    items = _ref.items,
    offer = _ref.offer,
    offers = _ref.offers,
    quantity = _ref.quantity,
    recipient = _ref.recipient,
    shippingAddress = _ref.shippingAddress,
    shippingMethod = _ref.shippingMethod,
    skuId = _ref.skuId,
    token = _ref.token,
    valueAddedServices = _ref.valueAddedServices,
    visitId = _ref.visitId,
    visitorId = _ref.visitorId;
  return function (dispatch) {
    var service = SERVICE_UPDATE_ITEM;
    var itemDataToMerge = createItemData();
    var params = {
      host: host,
      cloudStack: cloudStack,
      token: token,
      visitId: visitId,
      visitorId: visitorId,
      appId: appId,
      brand: brand,
      channel: channel,
      country: country,
      items: items ? items.map(function (item) {
        return _objectSpread(_objectSpread({}, itemDataToMerge), item);
      }) : [_objectSpread({
        giftCard: giftCard,
        id: id,
        offer: offer,
        offers: offers,
        quantity: quantity,
        recipient: recipient,
        shippingAddress: shippingAddress,
        shippingMethod: shippingMethod,
        skuId: skuId,
        valueAddedServices: valueAddedServices
      }, itemDataToMerge)]
    };
    dispatch(onFetchStart(_objectSpread({
      service: service
    }, params)));
    return replaceItemsByParams(params).then(function (payload) {
      return dispatch(onFetchSuccess(_objectSpread({
        service: service
      }, payload)));
    }, function (error) {
      return dispatch(handleCartErrors({
        service: service,
        params: params,
        error: error
      }));
    });
  };
}